import { useEffect } from 'react'

// Lightweight per-route SEO for our SPA: sets a unique <title>, meta
// description, Open Graph/Twitter tags and canonical for each page. Google
// runs JS and reads these, so each marketing page can rank on its own terms
// instead of every page sharing the homepage's tags.
const SITE = 'Okoiya'
const BASE = 'https://okoiya.com'
const DEFAULT_TITLE = 'Okoiya | The Wedding Hub'

function setMeta(key, content, attr = 'name') {
  if (!content) return
  let el = document.head.querySelector(`meta[${attr}="${key}"]`)
  if (!el) { el = document.createElement('meta'); el.setAttribute(attr, key); document.head.appendChild(el) }
  el.setAttribute('content', content)
}
function setCanonical(href) {
  let el = document.head.querySelector('link[rel="canonical"]')
  if (!el) { el = document.createElement('link'); el.setAttribute('rel', 'canonical'); document.head.appendChild(el) }
  el.setAttribute('href', href)
}

export function useSeo({ title, description, path = '/' }) {
  useEffect(() => {
    const fullTitle = title ? `${title} · ${SITE}` : DEFAULT_TITLE
    const url = BASE + (path || '/')
    document.title = fullTitle
    setMeta('description', description)
    setMeta('og:title', fullTitle, 'property')
    setMeta('og:description', description, 'property')
    setMeta('og:url', url, 'property')
    setMeta('twitter:title', fullTitle)
    setMeta('twitter:description', description)
    setCanonical(url)
  }, [title, description, path])
}
